module.exports = __webpack_public_path__ + "img/symbol_9.89ac4d2a.png";